<section class="animated fadeIn welcome-component">

  <div class="welcome-component__container">

    <header class="welcome-component__header">

      <h1 class="title">
        Welcome
      </h1>

      <div class="welcome-message-container">

        <span class="subtitle">
          Choose Your Pet’s Food – Make Mealtime Effortless
        </span>

        <p class="text-secondary-700 fw-semibold m-0">
          Keep your dog or cat happy and healthy with nutritious meals delivered right to your door. With flexible
          subscription options every 2 to 8 weeks, you’re in full control of your schedule. Set it once and relax, or
          log in anytime to update meals, add treats, or toss in a toy.
        </p>

        <p class="text-secondary-700 fw-semibold m-0">
          Subscriptions aren’t required, but they’re the easiest way to stay stocked and stress-free. Pick a plan,
          personalize it to your pet’s needs, and enjoy worry-free mealtimes.
        </p>

      </div>

      @if(!isMobile() && groupedProducts().length) {
      <section class="welcome-component__buttons pb-2">
        <button type="button" class="btn w-auto btn-outline-secondary mt-4" (click)="goToShop()">
          Skip For Now
        </button>
      </section>
      }


    </header>

    <hr>

    <!-- Products -->
    <section class="welcome-component__products">

      @defer (when groupedProducts().length) {
      <mat-tab-group mat-stretch-tabs="false">
        @for (group of groupedProducts(); track $index) {
        <mat-tab [label]="group.subcategoryName">
          <div class="row m-0">
            @let products = group.products;
            @if (products.length) {
            @for (product of products; track product.id) {
            @defer (on viewport; prefetch on immediate) {
            <div class="col-xxl-3 col-lg-4 col-6 p-0" id="{{product.id}}" (mouseenter)="onProductCardHover(product.id)">
              <div class="product-card-grid__item">
                @let productDetails = this.productDetails().get(product.id);
                <app-product-card-v2 [isFromWelcome]="true"
                  [cardResume]="{ product, settings: {}, productDetails:  productDetails}"
                  (onComponentReady)="onProductCardReady(product.id)" [isFromShop]="!!productDetails">
                </app-product-card-v2>
              </div>
            </div>
            } @placeholder {
            <div class="col-xxl-3 col-lg-4 col-6 p-0" id="{{product.id}}">
              <div class="product-card-grid__item__placeholder">
              </div>
            </div>
            }
            }
            }
          </div>
        </mat-tab>
        }
      </mat-tab-group>
      } @placeholder {
      <div class="loading z-n1">
        <div class="loader">
          @for (item of [0,0,0,0,0]; track $index) {
          <div class="bg-secondary"></div>
          }
        </div>
      </div>
      }

    </section>

    <!-- Buttons -->
    @if(!isMobile() && groupedProducts().length) {
    <footer class="welcome-component__buttons">
      <button type="button" class="btn btn-outline-secondary" (click)="goToShop()">
        Explore Store
      </button>
    </footer>
    }

  </div>

</section>

@if (isMobile() && groupedProducts().length) {
<footer class="stickyBottom">
  <section class="d-flex align-items-center justify-content-center stickyBottom__buttons">
    <button type="button" class="btn btn-outline-secondary w-100" (click)="goToShop()">
      Explore Store
    </button>
  </section>
</footer>
}